import notificationApi from 'api/notificationApi';
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { logout } from '../auth/index';
import ManageCmsBlogApi from 'api/manageCMSBlogApi';
import { showToastError } from '@core/components/toastify/ToastTypes';

const initialState = {
  conferences: undefined,
  themeColor: undefined,
  buttonColor: undefined,
  colorText: undefined,
  menuColor: undefined,
};

const SettingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setConferences: (state, action) => {
      state.conferences = action.payload;
    },

    setThemeColor: (state, action) => {
      state.themeColor = action.payload;
    },
    setButtonColor: (state, action) => {
      state.buttonColor = action.payload;
    },
    setColorText: (state, action) => {
      state.colorText = action.payload;
    },
    setMenuColor: (state, action) => {
      state.menuColor = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const {
  setConferences,
  setThemeColor,
  setButtonColor,
  setColorText,
  setMenuColor,
} = SettingSlice.actions;

export const getConferences = (state) => state.settings.conferences;
export const getThemeColor = (state) =>
  typeof localStorage !== 'undefined' &&
  localStorage.getItem('colorThemeLocal') !== null &&
  localStorage.getItem('colorThemeLocal') !== ''
    ? JSON.parse(localStorage.getItem('colorThemeLocal'))?.themeColor
    : state.settings.themeColor;

export const getColor = (state) =>
  typeof localStorage !== 'undefined' &&
  localStorage.getItem('colorThemeLocal') !== null &&
  localStorage.getItem('colorThemeLocal') !== ''
    ? JSON.parse(localStorage.getItem('colorThemeLocal'))?.buttonColor
    : state.settings.buttonColor;

export const getColorText = (state) =>
  typeof localStorage !== 'undefined' &&
  localStorage.getItem('colorThemeLocal') !== null &&
  localStorage.getItem('colorThemeLocal') !== ''
    ? JSON.parse(localStorage.getItem('colorThemeLocal'))?.buttonTextColor
    : state.settings.colorText;

export const getColorMenu = (state) =>
  typeof localStorage !== 'undefined' &&
  localStorage.getItem('colorThemeLocal') !== null &&
  localStorage.getItem('colorThemeLocal') !== ''
    ? JSON.parse(localStorage.getItem('colorThemeLocal'))?.menuTextColor
    : state.settings.menuColor;

export default SettingSlice.reducer;

const labelConfig = (key, value) => {
  const modifyLabel = {
    lessonReminder: 'Class Reminder',
    liveLessonReminder: 'Lessons Reminder',
  };
  return modifyLabel.hasOwnProperty(key) ? modifyLabel[key] : value;
};

// -----------------------
// action async to get event and typeuser in notification component
//------------------------
export async function getListEvents() {
  const result = await (async () => {
    try {
      const response = await notificationApi.getEvent();

      const dataEvent = await Object?.entries(response)?.map(
        ([key, value]) => ({
          value: value,
          label: labelConfig(key, value),
          key,
        }),
      );
      return dataEvent;
    } catch (error) {
      showToastError(error);
    }
  })();
  return result;
}

export async function getListUserTypes() {
  const result = await (async () => {
    try {
      const response = await notificationApi.getUserType();
      const data = Object?.keys(response)?.map((item) => {
        let label = item?.replaceAll('_', ' ').toLowerCase();
        label = label[0].toUpperCase() + label.slice(1);
        return {
          value: item,
          label,
        };
      });
      return data;
    } catch (error) {
      showToastError(error);
    }
  })();
  return result;
}

export function getColorThemeAsync() {
  return async function (dispatch) {
    const response = await ManageCmsBlogApi.getEnrollStatus();
    if (response?.length) {
      let colorObj = {};
      response?.map((data) => {
        if (data?.key == 'themeColor') {
          dispatch(setThemeColor(data?.value));
          colorObj.themeColor = data?.value;
        }
        if (data?.key == 'buttonColor') {
          dispatch(setButtonColor(data?.value));
          colorObj.buttonColor = data?.value;
        }
        if (data?.key == 'buttonTextColor') {
          dispatch(setColorText(data?.value));
          colorObj.buttonTextColor = data?.value;
        }
        if (data?.key == 'menuTextColor') {
          dispatch(setMenuColor(data?.value));
          colorObj.menuTextColor = data?.value;
        }
      });
      localStorage.setItem('colorThemeLocal', JSON.stringify(colorObj));
    }
  };
}
